import { useEffect, useRef, useState } from 'react'
import { debounce } from '../helpers/common'

export const CalculateSize = ({ children, height, keyChange }) => {
  const ref = useRef()
  const [size, setSize] = useState({})

  useEffect(() => {
    setTimeout(() => {
      calcSize()
    }, 0)
  }, [height, keyChange])

  useEffect(() => {
    const resize = debounce(() => {
      setTimeout(() => {
        calcSize()
      }, 0)
    }, 100)

    window.addEventListener('resize', resize)

    return () => window.removeEventListener('resize', resize)
  }, [])

  const calcSize = () => {
    if (ref.current) {
      setSize({
        width: ref.current.getBoundingClientRect().width,
        height: ref.current.getBoundingClientRect().height,
      })
    }
  }

  return (
    <>
      {(size.height || size.height === 0) && children(size)}
      <div
        ref={ref}
        style={{ width: '100%', height, position: 'absolute', top: -99999 }}
      />
    </>
  )
}
